<template>
  <div>
    <FormationGesturePostureComp v-bind:mobile="mobile"/>
    <RedirectEnterpriseComp v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import FormationGesturePostureComp from '@/components/desktop/Enterprise/FormationGesturePostureComp'
import RedirectEnterpriseComp from '@/components/desktop/Enterprise/RedirectEnterpriseComp'

  export default {
    name: 'FormationGesturePosture',
    props: ['mobile'],
    components: {
      FormationGesturePostureComp,
      RedirectEnterpriseComp
    },
  }
</script>
